<template>
    <v-app>
        <Drawer current_item="menu_staff"></Drawer>

        <v-dialog v-model="dialog_force_new_password" max-width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>บังคับรหัสผ่านใหม่</v-card-title>
          <v-card-text>
            <v-text-field type="password" v-model="force_new_password" outlined class="mt-6" label="รหัสผ่านใหม่"></v-text-field>
            <v-text-field type="password" v-model="force_new_password_confirm" outlined class="mt-n3" label="ยืนยันรหัสผ่านใหม่"></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn :disabled="!is_force_new_password" color="primary" text @click="submitforceNewPassword">เปลี่ยนรหัสผ่าน</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <v-dialog v-model="dialog_force_new_email" max-width="500">
        <v-card>
          <v-card-title class="headline grey lighten-2" primary-title>บังคับอีเมลใหม่</v-card-title>
          <v-card-text>
            <v-text-field v-model="force_new_email" outlined class="mt-6" label="อีเมลใหม่"></v-text-field>
          </v-card-text>
          <v-divider></v-divider>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="primary" text @click="submitforceNewEmail">เปลี่ยนอีเมล</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

        <v-main>

            <v-banner single-line :sticky="true" style="background-color:white">
                <v-row align="end" justify="space-between">
                    <v-col cols="12" md="8" class="text-md-h4 text-h5" align="left">
                        #{{ detail.staff_code }}
                        </v-col>
                    <v-col cols="12" md="4" align="left">
                        <!--<v-btn tile color="success" @click="submitChange" :disabled="!is_change" >
                            <v-icon left>mdi-check</v-icon>{{ $t('config_submit') }}
                        </v-btn>-->
                    </v-col>

                </v-row>
            </v-banner>

            <v-divider></v-divider>

            <div class="ml-6 mr-6" align="left">

            <v-card
                    class="mx-auto mt-4 mr-6 pa-4"
                    outlined
                    elevation=3
                >

                <div class="mt-4">ชื่อเจ้าหน้าที่ : {{ detail.displayname }}</div>
                <div class="mt-2">ชื่อผู้ใช้งาน : {{ detail.username }}</div>
                <div class="mt-2">อีเมล : {{ detail.email }}
                        <v-chip
                            class="ml-2 mr-2"
                            color="green"
                            text-color="white"
                            v-if="detail.is_have_email != undefined && detail.is_have_email"
                        >
                            พบอีเมลนี้ในระบบ
                        </v-chip>
                        <v-chip
                            class="ml-2 mr-2"
                            color="red"
                            text-color="white"
                            v-if="detail.is_have_email != undefined && !detail.is_have_email"
                        >
                            ไม่พบอีเมลนี้ในระบบ
                        </v-chip>
                    <v-btn v-if="username=='admin'" color="primary" @click="forceNewEmail">บังคับอีเมลใหม่</v-btn>
                </div>
                <div class="mt-2">รหัสผ่าน : 
                    <v-btn v-if="username=='admin'" color="error" @click="forceNewPassword">บังคับรหัสผ่านใหม่</v-btn>
                </div>
                <div class="mt-2">จุดบริการ : 
                    <v-list>
                        <v-list-item
                            v-for="(item, index) in detail.station_list"
                            :key="index"
                        >
                        {{ item }}
                        <v-chip
                            class="ml-2"
                            color="green"
                            text-color="white"
                            v-if="detail.is_friend && detail.is_friend.filter(s=>s.station_name==item).length > 0 && detail.is_friend.filter(s=>s.station_name==item)[0].is_friend"
                        >
                            พบอีเมลนี้ในรายชื่อเพื่อน
                        </v-chip>
                        <v-chip
                            class="ml-2"
                            color="red"
                            text-color="white"
                            v-if="detail.is_friend && detail.is_friend.filter(s=>s.station_name==item).length > 0 && !detail.is_friend.filter(s=>s.station_name==item)[0].is_friend"
                        >
                            ไม่พบอีเมลนี้ในรายชื่อเพื่อน
                        </v-chip>
                        </v-list-item>
                    </v-list>
                </div>
                <div class="mt-2">ระดับเจ้าหน้าที่ : {{ detail.staff_type == 1 ? 'ผู้ควบคุมระบบ' : 
                                                    (detail.staff_type == 2 ? 'ตัวแทนจุดบริการ' : 
                                                    (detail.staff_type == 3 ? 'เจ้าหน้าที่ระดับสูง' : 'เจ้าหน้าที่')) }}</div>
                    
            </v-card>

            <v-card v-if="detail.staff_type==4"
                    class="mx-auto mt-4 mr-6 pa-4"
                    outlined
                    elevation=3
                >

                <div class="mt-4 mb-4">กลุ่มงานบริการที่ดูแล : {{ detail.group_list.join(',') }}</div>
                
                    
            </v-card>

            </div>

        </v-main>
    </v-app>
</template>

<script>

import config from '@/../config.js'
import Staff from '@/model/instance/Staff.js'
import axios from 'axios';

import Drawer from '@/components/Drawer.vue'

export default {
    components: {
        Drawer
    },
    data () {
        return {
            detail : {}
            ,username : ""
            ,customerList : []
            ,customer : {}

            ,dialog_force_new_password : false
            ,force_new_password : ""
            ,force_new_password_confirm : ""

            ,dialog_force_new_email : false
            ,force_new_email : ""
        }
    },
    computed : {
        is_force_new_password(){
            return this.force_new_password.length > 0 && this.force_new_password == this.force_new_password_confirm
        }
    },
    mounted : function () {
        this.username = Staff.getUsername()
        if(this.username=='admin'){
            this.customerList = [];
            var que = this.$store.commit('addLoading')
            axios.get(
                config.api.url.manage.customer.list,
                { headers: Staff.getTokenHeader()}
            ).then(rs => {
                this.$store.commit('finishLoading',que)
                this.customerList = rs.data;
                this.reload()
            })
        }else{
            this.reload()
        }
    },
    methods : {
        forceNewEmail(){
            this.force_new_email = ""
            this.dialog_force_new_email = true
        },
        forceNewPassword(){
            this.force_new_password = ""
            this.force_new_password_confirm = ""
            this.dialog_force_new_password = true
        },
        submitforceNewEmail(){
            var que = this.$store.commit('addLoading')
            axios
            .post(config.api.url.manage.staff.update_force_new_email,{
                staff_id : this.$route.params.staff_id
                ,force_new_email : this.force_new_email
            },{ headers: Staff.getTokenHeader()}
            ).then(() => {
                this.$store.commit('finishLoading',que)
                this.force_new_email = ""
                this.dialog_force_new_email = false
                this.reload()
            })
        },
        submitforceNewPassword(){
            var que = this.$store.commit('addLoading')
            axios
            .post(config.api.url.manage.staff.update_force_new_password,{
                staff_id : this.$route.params.staff_id
                ,force_new_password : this.force_new_password
            },{ headers: Staff.getTokenHeader()}
            ).then(() => {
                this.$store.commit('finishLoading',que)
                this.force_new_password = ""
                this.force_new_password_confirm = ""
                this.dialog_force_new_password = false
            })
        },
        changeCustomer(c){
            var que = this.$store.commit('addLoading')
            axios
            .post(config.api.url.manage.staff.map_customer,{
                staff_id : this.$route.params.staff_id
                ,customer_id : c
            },{ headers: Staff.getTokenHeader()}
            ).then(() => {
                this.$store.commit('finishLoading',que)
                this.reload()
            })
        },
        reload(){
            var que = this.$store.commit('addLoading')
            axios
            .post(config.api.url.manage.staff.get_stafflist,{},{ headers: Staff.getTokenHeader()}
            ).then(response => {

                this.detail = {}
                Object.keys(response.data).forEach(key=>{
                    response.data[key].forEach(r=>{
                        if(r.staff_id == this.$route.params.staff_id){
                            this.detail = r
                            console.log(this.detail)
                            if(key=='adminlist'){
                                this.detail['staff_type'] = 1
                            }else if(key=='creatorlist'){
                                this.detail['staff_type'] = 2
                            }else if(key=='supervisorlist'){
                                this.detail['staff_type'] = 3
                            }else if(key=='viewerlist'){
                                this.detail['staff_type'] = 4
                            }
                        }
                    })
                })
                this.$store.commit('finishLoading',que)
            })
            .catch(error => {
                this.$router.push({name:'Error',params:error}) 
            })
        }
    }
}

</script>